export enum ReportStatuses {
  Pending = 'PENDING',
  Dismissed = 'DISMISSED',
  ActionTaken = 'ACTION_TAKEN',
}
